import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { Menu, X, Home, Info, Phone, LogIn, Rocket, CreditCard } from "lucide-react";
import { getUser } from "../api/auth";

const Header = ({ loginClick = () => { } }) => {
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    const userDetail = getUser();

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 20);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    // Close mobile menu when route changes
    useEffect(() => {
        setMenuOpen(false);
    }, [location]);

    // Navigation items configuration
    const navItems = [
        { path: "/", label: "Home", icon: <Home size={18} /> },
        { path: "/about", label: "About", icon: <Info size={18} /> },
        { path: "/contact", label: "Contact", icon: <Phone size={18} /> },
        // { path: "/plans", label: "Pricing", icon: <CreditCard size={18} /> },
    ];

    const handleClick = () => {
        navigate(userDetail ? "/dashboard" : "/");
    };

    return (
        <>
            <header
                className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ease-in-out
                    ${scrolled
                        ? "bg-white/70 backdrop-blur-xl  shadow-lg"
                        : "bg-transparent"
                    }`}
            >
                <div className="max-w-7xl mx-auto px-4 ">
                    <div className="flex items-center justify-between h-16 md:h-20">

                        {/* Logo Section - Left */}
                        <div className="flex items-center ">
                            <div onClick={() => handleClick()} className="flex items-center justify-center gap-3 cursor-pointer">
                                <img src='./images/ctv_logo.png' className="h-12 w-12 text-black transform rotate-180" alt='logo' />
                                <span className="text-2xl font-bold mb-[9px]">
                                    SocialTV
                                </span>
                            </div>
                        </div>

                        {/* Desktop Navigation - Center - FIXED */}
                        <nav className="hidden md:flex items-center justify-center gap-2 lg:gap-5 flex-1 mx-8">
                            {navItems.map((item) => (
                                <NavLink
                                    key={item.path}
                                    to={item.path}
                                    // className={({ isActive }) => `
                                    //     relative px-1 py-2 rounded-full
                                    //     flex items-center gap-2
                                    //     transition-all duration-300 ease-in-out
                                    //     whitespace-nowrap
                                    //     ${isActive
                                    //         ? " text-purple-600 font-semibold"
                                    //         : 'text-gray-600'
                                    //     }

                                    //     after:absolute after:left-0 after:bottom-0
                                    //     after:h-[2px] after:w-full
                                    //     after:bg-purple-600
                                    //     after:origin-center
                                    //     after:scale-x-0
                                    //     after:transition-transform after:duration-300
                                    //     hover:after:scale-x-100
                                    //     ${!isActive && ""}
                                    // `}
                                    className={({ isActive }) => `
                                        relative px-1 py-2 rounded-full
                                        flex items-center gap-2
                                        transition-all duration-300 ease-in-out
                                        whitespace-nowrap
                                        ${isActive
                                            ? " text-[#ff6968] font-semibold"
                                            : 'text-gray-600'
                                        }

                                        after:absolute after:left-0 after:bottom-0
                                        after:h-[2px] after:w-full
                                        after:bg-[#ff6968]
                                        after:origin-center
                                        after:scale-x-0
                                        after:transition-transform after:duration-300
                                        hover:after:scale-x-100
                                        ${!isActive && ""}
                                    `}
                                >
                                    <span className="transition-transform duration-300">
                                        {item.icon}
                                    </span>
                                    <span className="text-sm lg:text-base">{item.label}</span>
                                </NavLink>
                            ))}
                        </nav>

                        {/* Desktop Actions - Right */}
                        <div className="hidden md:flex items-center gap-3 flex-shrink-0">
                            <div
                                onClick={() => {
                                    loginClick();
                                }}
                                className={`
                                    cursor-pointer
                                    px-5 py-2 rounded-xl
                                    flex items-center gap-2
                                    transition-all duration-300
                                    whitespace-nowrap
                                    border border-gray-300 bg-white hover:bg-gray-50 text-gray-700
                                `}
                            >
                                <LogIn size={18} />
                                <span>Login</span>
                            </div>

                            {/* <div
                                onClick={loginClick}
                                className={`
                                    cursor-pointer
                                    px-5 py-2 rounded-xl
                                    flex items-center gap-2
                                    transition-all duration-300 transform hover:scale-105
                                    bg-gradient-to-r from-purple-600 to-blue-600
                                    text-white shadow-lg hover:shadow-xl
                                    whitespace-nowrap
                                `}
                            >
                                <Rocket size={18} />
                                <span>Get Started</span>
                            </div> */}

                            <div
                                onClick={loginClick}
                                className={`
        cursor-pointer
        px-5 py-2 rounded-xl
        flex items-center gap-2
        transition-all duration-300 transform hover:scale-105
        bg-gradient-to-r from-[#ff6968] via-[#ff6968] to-rose-500
        text-white shadow-lg hover:shadow-[#ff6968]/30 hover:shadow-xl
        whitespace-nowrap
    `}
                            >
                                <Rocket size={18} />
                                <span>Get Started</span>
                            </div>


                        </div>

                        {/* Mobile Menu Button */}
                        <button
                            className={`md:hidden p-2 rounded-lg transition-all duration-300
                             hover:bg-gray-100 text-gray-700`}
                            onClick={() => setMenuOpen(true)}
                            aria-label="Open menu"
                        >
                            <Menu size={24} />
                        </button>
                    </div>
                </div>
            </header>

            {/* Mobile Menu Overlay */}
            <div
                className={`fixed inset-0 z-50 bg-black/50 backdrop-blur-sm transition-all duration-300
                    ${menuOpen ? "opacity-100 visible" : "opacity-0 invisible"}`}
                onClick={() => setMenuOpen(false)}
            />

            {/* Mobile Menu Panel */}
            <div
                className={`fixed top-0 right-0 h-full w-80 bg-white z-[51] 
                    transform transition-transform duration-500 ease-in-out
                    ${menuOpen ? "translate-x-0" : "translate-x-full"}`}
            >
                <div className="flex justify-between items-center p-4 border-b border-gray-100">
                    <div className="flex items-center gap-2">
                        <img src="./images/ctv_logo.png" className="h-8 w-8" alt="logo" />
                        <span className="font-bold text-lg mt-2">SocialTV</span>
                    </div>
                    <button
                        onClick={() => setMenuOpen(false)}
                        className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
                        aria-label="Close menu"
                    >
                        <X size={24} />
                    </button>
                </div>

                <nav className="flex flex-col p-6 gap-2">
                    {navItems.map((item) => (
                        <NavLink
                            key={item.path}
                            to={item.path}
                            onClick={() => setMenuOpen(false)}
                            // className={({ isActive }) => `
                            //     flex items-center gap-3 px-4 py-3 rounded-xl
                            //     transition-all duration-300
                            //     ${isActive
                            //         ? "bg-gradient-to-r from-purple-50 to-blue-50 text-purple-600 font-semibold"
                            //         : "text-gray-700 hover:bg-gray-50"
                            //     }
                            // `}
                            className={({ isActive }) => `
                                flex items-center gap-3 px-4 py-3 rounded-xl
                                transition-all duration-300
                                ${isActive
                                    ? "bg-gradient-to-r from-[#ff6968]/10 to-rose-50 text-[#ff6968] font-semibold"
                                    : "text-gray-700 hover:bg-gray-50"
                                }
                            `}
                        >
                            {item.icon}
                            <span>{item.label}</span>
                            {({ isActive }) => isActive && (
                                <span className="ml-auto w-1.5 h-1.5 rounded-full bg-purple-600"></span>
                            )}
                        </NavLink>
                    ))}

                    <div className="h-px bg-gray-200 my-4"></div>

                    <NavLink
                        onClick={() => { setMenuOpen(false); loginClick() }}
                        // className={({ isActive }) => `
                        //     flex items-center gap-3 px-4 py-3 rounded-xl
                        //     transition-all duration-300 border
                        //     ${isActive
                        //         ? "border-purple-200 bg-purple-50 text-purple-600"
                        //         : "border-gray-200 text-gray-700 hover:bg-gray-50"
                        //     }
                        // `}
                        className={({ isActive }) => `
                            flex items-center gap-3 px-4 py-3 rounded-xl
                            transition-all duration-300 border
                            ${isActive
                                ? "border-[#ff6968]/30 bg-gradient-to-r from-[#ff6968]/10 to-rose-50 text-[#ff6968]"
                                : "border-gray-200 text-gray-700 hover:bg-gray-50"
                            }
                        `}
                    >
                        <LogIn size={18} />
                        <span>Login</span>
                    </NavLink>

                    {/* <NavLink
                        onClick={() => { setMenuOpen(false); loginClick() }}
                        className={({ isActive }) => `
                            flex items-center gap-3 px-4 py-3 rounded-xl
                            transition-all duration-300 mt-2
                            bg-gradient-to-r from-purple-600 to-blue-600
                            text-white shadow-md
                            ${isActive ? "ring-2 ring-purple-400" : ""}
                        `}
                    >
                        <Rocket size={18} />
                        <span>Get Started</span>
                    </NavLink> */}

                    <NavLink
                        onClick={() => { setMenuOpen(false); loginClick() }}
                        className={({ isActive }) => `
                            flex items-center gap-3 px-4 py-3 rounded-xl
                            transition-all duration-300 mt-2
                            bg-gradient-to-r from-[#ff6968] via-[#ff6968] to-rose-500
                            text-white shadow-md
                        `}
                    >
                        <Rocket size={18} />
                        <span>Get Started</span>
                    </NavLink>
                </nav>
            </div>
        </>
    );
};

export default Header;